'use client';

import { FC } from 'react';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { useAppState } from '@/state/hooks/app.state.hook';

export const FooterLinkModal: FC = () => {
  const { infoModalUrl, closeInfoModal } = useAppState();

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) closeInfoModal();
  };

  return (
    <Dialog open={Boolean(infoModalUrl)} onOpenChange={handleOpenChange}>
      <DialogContent
        data-testid="PortalFooter-LinkModal"
        aria-describedby={undefined}
        className="flex h-[85vh] max-w-4xl flex-col p-0 pt-10"
      >
        <DialogTitle className="sr-only">{infoModalUrl}</DialogTitle>
        {infoModalUrl && (
          <iframe
            src={infoModalUrl}
            title={infoModalUrl}
            className="size-full flex-1 rounded-b-lg border-0"
            data-testid="PortalFooter-LinkModalFrame"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
